document.addEventListener("DOMContentLoaded", function () {
    const quickViewModal = document.getElementById("quick-view-modal");
    const quickViewContainer = document.getElementById("quick-view-container");

    // Close the modal
    function closeModal() {
        quickViewModal.classList.add("hidden");
        document.querySelector("body").classList.remove("quick-view-open");
        quickViewContainer.innerHTML = ""; // Clear previous content
    }

    // Event listener for closing the modal
    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("close-modal")) {
            closeModal();
        }
    });
    document.querySelector(".close-modal svg").addEventListener("click", function (event) {
        closeModal();
    });

    // Event listener for quick view button clicks
    document.addEventListener("click", function (event) {
        const button = event.target.closest(".quick-view-btn");
        if (button) {
          
            event.preventDefault();  // Prevent any default action
            event.stopPropagation(); // Stop event from bubbling up

            const productHandle = button.getAttribute("data-handle");

            fetch(`/products/${productHandle}?view=quick`)
                .then(response => response.text())
                .then(data => {
                    quickViewModal.classList.remove("hidden");
                    document.querySelector("body").classList.add("quick-view-open");
                    return quickViewContainer.innerHTML = data;
                  })
                .then(() => {

                    var po = document.createElement('script');
                    po.type = 'text/javascript';
                    po.async = false;
                    po.src = 'https://cdn.judge.me/loader.js';
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(po, s);
                    // varinat-custom-poup
                    var dogIndex = 0;
                    var current_varinat_id = document.getElementById('custom_current_varinat_id');
                    var dogContainer = document.getElementById('dog-container');
                    var summarySection = document.getElementById('summary-section');
                    var summaryList = document.getElementById('summary-list');
                    var addDogBtn = document.getElementById('add-dog-btn');
                    var variantInput = document.getElementById('custom_dog_variant_id');
                    var countInput = document.getElementById('custom_dog_value');
                    var variantBasePrice = document.getElementById('custom_dog_variant_base_price');
                    var customVariations = document.querySelectorAll('.custom-variant-metafield');

                    if(current_varinat_id)
                    {
                    function createDogEntry(index, previous_variant_id = null) {
                      var div = document.createElement('div');
                      div.className = 'dog-entry';
                      div.dataset.index = index;
                  
                      var optionsHTML = '<h4>CHOOSE YOUR DOG SIZE</h4><div class="cst-dog-opt"><div class="dog-options">';
                      customVariations.forEach((variant) => {
                        const variantId = variant.dataset.variantId;
                        const isChecked = (previous_variant_id ? previous_variant_id == variantId : current_varinat_id.value == variantId) ? 'checked' : '';
                      
                        optionsHTML += `
                          <label>
                            <input class="dog_size_radio" type="radio" name="dog-size-${index}" value="${variantId}" 
                              data-price="${variant.dataset.price}" 
                              data-title="${variant.dataset.title}" 
                              ${isChecked}>
                            <strong>${variant.dataset.title}</strong> ${variant.dataset.weight}<br>
                            <small>${variant.dataset.ship}</small>
                          </label>
                        `;
                      });
                      optionsHTML += `
                      </div><div class="buttons-sec">`;
                         if(document.querySelector('#summary-list .summary-item'))
                        {
                          optionsHTML += `
                            <button class="cancel-dog-action" onclick="cancelDog(${index})">Cancel</button>
                          `;
                        }
                        optionsHTML += `
                            <button class="add-dog-action" onclick="submitDog(${index})">Add Dog</button>
                          </div></div>`;
                      
                      div.innerHTML = optionsHTML;
                      setTimeout(() => {
                        var radios = div.querySelectorAll('.dog_size_radio');
                        radios.forEach(radio => {
                          radio.addEventListener('change', function (e) {
                            const price = parseFloat(e.target.dataset.price);
                            if (!isNaN(price) && countInput.value == 0) {
                              variantBasePrice.value = price.toFixed(2);
                              variantInput.value = e.target.value;
                              if(document.querySelector('button.product-form__submit .custom-variant-price'))
                                document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${variantBasePrice.value}`;
                              updatePrices();
                            }
                          });
                        });
                      }, 0);
                     // console.log(div);
                      dogContainer.appendChild(div);
                      //console.log(dogContainer);
                    }
                    function submitDog(index) {
                      var entry = dogContainer.querySelector(`.dog-entry[data-index="${index}"]`);
                      if (!entry) return;
                  
                      var selected = entry.querySelector('input[type="radio"]:checked');
                      var value = selected.value;
                      var selected_price = selected.dataset.price;
                  
                      // Update variant input
                      if(countInput.value > 0)
                      {
                        var variants = variantInput.value ? variantInput.value.split(',') : [];
                        variants.push(value);
                        variantInput.value = variants.join(',');
                        variantBasePrice.value = (parseFloat(selected_price) + parseFloat(variantBasePrice.value)).toFixed(2);
                        if(document.querySelector('button.product-form__submit .custom-variant-price'))
                          document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${variantBasePrice.value}`;
                      }
                      else{
                        variantInput.value = value;
                        variantBasePrice.value = parseFloat(selected_price).toFixed(2);
                        if(document.querySelector('button.product-form__submit .custom-variant-price'))
                          document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${variantBasePrice.value}`;
                      }
                  
                      // Update count input
                      countInput.value = parseInt(countInput.value || 0) + 1;
                  
                      // Add to summary
                      var labelText = selected.parentElement.textContent.trim().split('\n')[0].trim();
                      var item = document.createElement('div');
                      item.className = 'summary-item';
                      item.dataset.index = value;  // variant id set
                      item.innerHTML = `
                        <span>${labelText}</span>
                        <button onclick="removeDog(${index}, ${value}, ${selected_price})">&times;</button>
                      `;
                      summaryList.appendChild(item);
                  
                      // Hide current dog entry
                      entry.remove();
                  
                      // Show summary and "Add Another Dog"
                      summarySection.style.display = 'block';
                      addDogBtn.style.display = 'block';
                      updatePrices();
                    }
                  
                    function removeDog(index, value, selected_price) {
                      // Remove from summary
                      // const item = summaryList.querySelector(`.summary-item[data-index="${value}"]`);
                      // if (item) item.remove();
                      document.querySelectorAll(`.summary-item[data-index="${value}"]`).forEach(el => el.remove());
                  
                      // Update variant input
                      var originalArray = variantInput.value.split(',');
                      var variants = variantInput.value.split(',').filter(v => v !== value.toString());
                      var removedCount = originalArray.length - variants.length;
                      variantInput.value = variants.join(',');
                  
                      variantBasePrice.value = (parseFloat(variantBasePrice.value) - (parseFloat(selected_price) * removedCount)).toFixed(2);
                      if(document.querySelector('button.product-form__submit .custom-variant-price'))
                        document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${variantBasePrice.value}`;
                      // Update count input
                      countInput.value = Math.max(0, parseInt(countInput.value || 0) - removedCount);
                  
                      // If no more dogs, reset UI
                      if (variants.length === 0) {
                        if(!document.querySelector("#dog-container .dog-entry"))
                        { 
                          startNewDogEntry(); // restart flow
                        }
                        if(countInput.value == 0) {
                          var start_checkedRadio = document.querySelector('.dog-options input[type="radio"]:checked');
                          if (start_checkedRadio) {
                            variantInput.value = start_checkedRadio.value;
                            variantBasePrice.value = start_checkedRadio.dataset.price;
                            if(document.querySelector('button.product-form__submit .custom-variant-price'))
                              document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${variantBasePrice.value}`;
                          }
                          if(document.querySelector('.cancel-dog-action'))
                            document.querySelector('.cancel-dog-action').style.display = 'none';
                        }
                      }
                      if(countInput.value == 0) {
                        summarySection.style.display = 'none';
                        addDogBtn.style.display = 'none';
                        if(document.querySelector('#summary-list .summary-item'))
                        {
                          var previous_variant_id = document.querySelector('#summary-list .summary-item').dataset.index; 
                          // Remove from summary
                          const item = summaryList.querySelector(`.summary-item[data-index="${previous_variant_id}"]`);
                          if (item) item.remove();
                          createDogEntry(1, previous_variant_id); // restart flow with previous select
                        }
                      }
                      updatePrices();
                    }
                    function cancelDog(index){
                      document.querySelectorAll(`#dog-container .dog-entry[data-index="${index}"]`).forEach(el => el.remove());
                      addDogBtn.style.display = 'block';
                    }
                  
                    function startNewDogEntry() {
                      createDogEntry(dogIndex++);
                      addDogBtn.style.display = 'none'; // hide until next submit
                    }
                  
                    // Initialize with the first dog input
                    window.submitDog = submitDog;
                    window.removeDog = removeDog;
                    window.cancelDog = cancelDog;
                    window.startNewDogEntry = startNewDogEntry;
                      startNewDogEntry();
                    }
                    // end varinat-custom-poup
                                        
                    // subscripbe-plan-popup
                    var basePrice = document.getElementById('custom_dog_variant_base_price');
                    var radioInputs = document.querySelectorAll('input[name="purchase_option"]');
                    var planOptions = document.querySelectorAll('.plan-option');
                    var subscriptionPriceSpan = document.getElementById('subscription-price');
                    var frequencySelect = document.getElementById('frequency');
                    var saveBadge = document.getElementById('save-badge');
                    var subscription_onetime_price = document.querySelector('.plan-option[data-type="onetime"] .final-price');
                    var subscription_base_price = document.querySelector('.plan-option[data-type="subscription"] .original-price');
                    var subscription_final_price = document.querySelector('.plan-option[data-type="subscription"] .final-price');
                  
                    var custom_subscribe_plan_id = document.getElementById("custom_subscribe_plan_id");
                    if(custom_subscribe_plan_id)
                    {
                    function updatePrices() {
                      var custom_dog_variant_base_price = document.getElementById('custom_dog_variant_base_price');
                      basePrice = parseFloat(custom_dog_variant_base_price.value);
                      var selectedFrequency = frequencySelect.options[frequencySelect.selectedIndex];
                      var discount = parseFloat(selectedFrequency.dataset.discount);
                      var discountedPrice = basePrice * (1 - discount / 100);
                      if(document.querySelector('input[name="purchase_option"]:checked').value == "subscription")
                        custom_subscribe_plan_id.value = selectedFrequency.value
                  
                  
                      subscription_onetime_price.textContent = `$${basePrice.toFixed(2)}`;
                      if(discount)
                      {
                        subscriptionPriceSpan.textContent = `$${discountedPrice.toFixed(2)}`;
                        subscription_base_price.textContent = `$${basePrice.toFixed(2)}`;
                        saveBadge.textContent = `Save ${discount}%`;
                        subscriptionPriceSpan.style.display = 'block';
                        saveBadge.style.display = 'block';
                        if(document.querySelector('button.product-form__submit .custom-variant-price') && document.querySelector('input[name="purchase_option"]:checked').value == "subscription")
                          document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${discountedPrice.toFixed(2)}`;
                      }
                      else{
                        subscription_base_price.textContent = `$${basePrice.toFixed(2)}`;
                        subscriptionPriceSpan.style.display = 'none';
                        saveBadge.style.display = 'none';
                        if(document.querySelector('button.product-form__submit .custom-variant-price') && document.querySelector('input[name="purchase_option"]:checked').value == "subscription")
                          document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${basePrice.toFixed(2)}`;
                      }
                    }
                  
                    radioInputs.forEach(input => {
                      input.addEventListener('change', () => {
                        planOptions.forEach(option => {
                          option.classList.remove('selected');
                          if (option.dataset.type === input.value) {
                            option.classList.add('selected');
                          }
                        });
                      });
                    });
                  
                    frequencySelect.addEventListener('change', updatePrices);
                  
                    // Initial calculation
                    //updatePrices();
                  
                    document.querySelectorAll('.plan-option input[name="purchase_option"]').forEach(radio => {
                        radio.addEventListener('change', function() {
                          const purchase_option = this.value;
                          if(purchase_option == "subscription")
                          {
                              document.querySelector('.plan-option[data-type="subscription"] .frequency-wrapper').style.display = 'block'; // hide until next submit
                              custom_subscribe_plan_id.value = frequencySelect.value;
                              updatePrices();
                          }
                          else{
                              document.querySelector('.plan-option[data-type="subscription"] .frequency-wrapper').style.display = 'none'; // hide until next submit
                              custom_subscribe_plan_id.value = "";
                              if(document.querySelector('button.product-form__submit .custom-variant-price'))
                                document.querySelector('button.product-form__submit .custom-variant-price').textContent = `$${document.getElementById('custom_dog_variant_base_price').value}`;
                          }
                        });
                      });
                    }
                    // end subscripbe-plan-popup

                  //start byu-now
                  document.querySelector('button.product-form__submit').addEventListener('click', function (e) {
                    e.preventDefault();
                      
                    var variantIds = document.getElementById('custom_dog_variant_id')?.value;
                    const quantity = document.querySelector('[name="quantity"]')?.value || 1;
                      
                      
                    if (!variantIds) {
                      variantIds = document.querySelector("product-form .product-variant-id").value
                      // alert('Please add at least one dog before adding to cart.');
                      // return;
                    }
                    else{
                      if(document.querySelector('input[name="purchase_option"]:checked').value == "subscription")
                      {
                        var sellingPlanId = document.getElementById('custom_subscribe_plan_id')?.value;
                      }
                      else{
                        var sellingPlanId = "";
                      }
                    }
                    var product_submit_button = document.querySelector('button.product-form__submit');
                    var loading_spinner = document.querySelector('button.product-form__submit .loading__spinner');
                    product_submit_button.classList.add('loading');
                    product_submit_button.setAttribute('aria-disabled', 'true');
                    loading_spinner.classList.remove("hidden");
                    // Split the comma-separated variant IDs into an array
                    const items = variantIds
                      .split(',')
                      .map(id => id.trim())
                      .filter(id => id !== '')
                      .map(id => ({
                        id: parseInt(id),
                        quantity: parseInt(quantity),
                        ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
                      }));
                  
                    // Submit all items at once
                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({ items })
                    })
                      .then(res => res.json())
                      .then(data => {
                        return updateCartDrawer();
                      })
                      .then(() => {
                        // const cartIcon = document.getElementById('cart-icon-bubble');
                        // if (cartIcon) {
                        //   cartIcon.dispatchEvent(new Event('click', { bubbles: true }));
                        // }
                        document.getElementById('cart-icon-bubble')?.addEventListener('click', function (e) {
                          e.preventDefault();
                          document.querySelector("cart-drawer").classList.add("active");
                        });
                        document.addEventListener('keydown', function (e) {
                          if (e.key === 'Escape') {
                            var cartDrawer = document.querySelector('cart-drawer');
                            if (cartDrawer?.classList.contains('active')) {
                              cartDrawer.classList.remove('active');
                            }
                          }
                        });
                        document.addEventListener('click', function (e) {
                          var cartDrawer = document.querySelector('cart-drawer');
                          var cartDrawer2 = document.querySelector('cart-drawer .drawer__inner');
                          var cartIcon = document.getElementById('cart-icon-bubble');
                        
                          // Make sure drawer is open, and click is outside both drawer and cart icon
                          if (
                            cartDrawer?.classList.contains('active') &&
                            !cartDrawer2.contains(e.target) &&
                            !cartIcon.contains(e.target)
                          ) {
                            cartDrawer.classList.remove('active');
                          }
                        });
                        document.querySelector("cart-drawer").classList.add("active");
                        document.querySelector("cart-drawer").classList.remove("is-empty");
                        product_submit_button.classList.remove('loading');
                        product_submit_button.removeAttribute('aria-disabled');
                        loading_spinner.classList.add("hidden");
                        closeModal();
                      })
                      .catch(error => {
                      });
                  });
                  async function updateCartDrawer() {
                    await fetch(`${routes.cart_url}`)
                      .then((response) => response.text())
                      .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        //const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                        const selectors = ['cart-drawer #CartDrawer', "#cart-icon-bubble"];
                        for (const selector of selectors) {
                          const targetElement = document.querySelector(selector);
                          const sourceElement = html.querySelector(selector);
                          if (targetElement && sourceElement) {
                            targetElement.replaceWith(sourceElement);
                          }
                        }
                      })
                      .catch((e) => {
                        console.error(e);
                      });
                  }
                  //end byu-now

                  
                })
                .catch(error => {
                    console.error("Quick view load failed:", error);
                    alert("Error loading product details. Please try again.");
                });
        }
    });

    // Close modal when clicking outside the content
    quickViewModal.addEventListener("click", function (event) {
        if (event.target === quickViewModal) {
            closeModal();
        }
    });
});
